import { Type } from '@angular/core';

export class ReportModule {
  constructor(public component: Type<any>, public config: any) {}
}
